<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="pipeSize_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Pipe Size -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.PIPE_SIZE' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #pipeSize_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.PIPE_SIZE' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        *ngIf="!isCustom"
        formControlName="pipeSize"
        name="pipeSize"
        class="input-select"
        [class.spinner]="loading"
        (selectionChange)="selectPipeSize($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.pipeSizeId">{{ x.pipeName }}</mat-option>
    </mat-select>
    <input *ngIf="isCustom" class="input-form-class" matInput formControlName="customPipeSize" name="custom_PipeSize" />
</div>
